<template>
    <div class="app-wrapper" :class="{'in-dev-mode' : inDevMode}">
        <Player v-if="startVideo" :startVideo="startVideo">
            <!-- <template v-slot:modals> -->
            <Modals />
            <!-- </template> -->
            <Nodes />
        </Player>
    </div>
</template>

<script>
import Player from './components/player/Player.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import Nodes from './components/nodes/Nodes';
import { FbPixel } from './lib/FbPixel';
import Analytics from '@lib/analytics/index';
// import projectSize from '@mixins/projectSize';
import projectSize from './mixins/projectSize';
import axios from 'axios';
import { getUrlParameter } from './lib/utils';
import Modals from './components/modals/Modals';

export default {
    name: 'app',

    created() {
        window.addEventListener('message', e => {
            // fat arrow to keep Vue scope in handler
            if (e.data && e.data.type === 'dynamicParams') {
                console.log('data passed from the parent window ', e.data);
                this.setDynamicParams(e.data.dynamicParams);
            }
        });
    },

    async mounted() {
        window.parent.postMessage('ready', '*');

        if (window.dataSource === 'api') {
            const req = await axios.get(
                window.playerConfig.apiUrl + '/player/' + window.projectId
            );
            window.data = req.data;
        }

        this.setData(window.data);

        window.fbPixel = new FbPixel(
            window.data.project.fbPixelId,
            window.data.project.title
        );

        window.analytics = new Analytics(window.data.project.id);

        this.startTransition(
            this.skipToNode ? this.skipToNode : this.project.start_node_id
        );

        this.loadFont();

        window.fbPixel.projectView();
    },

    mixins: [projectSize],

    components: {
        Player,
        Nodes,
        Modals
    },

    computed: {
        ...mapGetters(['activeVideoId', 'nodes', 'project']),
        inDevMode() {
            const params =
                URLSearchParams && new URLSearchParams(document.location.search);
            const env = params && params.get('env');
            return env && ['local1', 'local2'].includes(env);
        },
        startVideo() {
            if (!this.project) return false;

            if (this.skipToNode) {
                return this.nodes[this.skipToNode].media_id;
            }

            return this.nodes[this.project.start_node_id].media_id;
        },

        chapters() {
            return this.project.chapters ? this.project.chapter_items : false;
        },

        skipToNode() {
            return window.location.href.includes('startNodeId')
                ? getUrlParameter('startNodeId')
                : false;
        }
    },

    methods: {
        ...mapActions(['startTransition']),
        ...mapMutations([
            // 'loadVideo',
            'setData',
            'setDynamicParams'
        ]),

        loadFont() {
            // Load in the font
            window.WebFont.load({
                google: {
                    families: [this.project.font]
                }
            });

            // Set the body font
            document.body.style.fontFamily = this.project.font;
        }
    }
};
</script>

<style lang="scss">
body {
    margin: 0;
    overflow: hidden;
}
* {
    box-sizing: border-box;
}
.app-wrapper {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: black;
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    min-width: 100vw;
    height: 100vh;
    overflow: hidden;
    &.in-dev-mode {
        height: 56.25vw;
    }
}

.clickable {
    cursor: pointer;
}

// V Tooltip
.tooltip {
    display: block !important;
    z-index: 10000;
    font-size: 7px;
    text-transform: uppercase;
    letter-spacing: 1.2px;

    .tooltip-inner {
        background: black;
        color: white;
        border-radius: 5px;
        padding: 5px 5px;
    }

    .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
    }

    &[x-placement^='top'] {
        margin-bottom: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^='bottom'] {
        margin-top: 5px;

        .tooltip-arrow {
            border-width: 0 5px 5px 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-top-color: transparent !important;
            top: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^='right'] {
        margin-left: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 5px 0;
            border-left-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom-color: transparent !important;
            left: -4px;
            top: calc(50% - 2px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &[x-placement^='left'] {
        margin-right: 5px;

        .tooltip-arrow {
            border-width: 5px 0 5px 5px;
            border-top-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            right: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &.popover {
        $color: #f9f9f9;

        .popover-inner {
            background: $color;
            color: black;
            padding: 24px;
            border-radius: 2px;
            box-shadow: 0 5px 30px rgba(black, 0.1);
        }

        .popover-arrow {
            border-color: $color;
        }
    }

    &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.15s, visibility 0.15s;
    }

    &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.15s;
    }
}

::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
    background-color: rgba(193, 186, 186, 0.4);
    border-radius: 10px;
}
</style>

